const PRODUCTS = {
  POINTS: 'POINTS',
  SUBSCRIPTION: 'SUBSCRIPTION',
};
export default PRODUCTS;
